import React, { useEffect } from 'react';

import { NavigationWrapper } from '../NavigationWrapper';
import { Loading, SectionsWrapper } from '../BuildReports/BuildReports.styles';
import {
  fetchSettings,
  fetchPowerBiReports,
  createSharedPowerBiReport,
  removeSharedPowerBiReport,
  selectSettings,
  selectPowerBiReports,
  useAppDispatch,
  useAppSelector,
} from '../../../state';
import ShareSection from './ShareSection';
import { USER_ROLES } from '../../../types';
import { NoData } from './NoData';

interface IShareReportsProps {
  userName: string;
  userRole: string;
  isSharedReportstTab?: boolean;
}

export const ShareReports = ({
  userName,
  userRole,
  isSharedReportstTab,
}: IShareReportsProps) => {
  const settingsData = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();
  const powerBiReportsData = useAppSelector(selectPowerBiReports);

  useEffect(() => {
    if (
      !settingsData.settings &&
      !settingsData.loading &&
      !settingsData.failed
    ) {
      dispatch(fetchSettings());
    }

    if (
      !powerBiReportsData.reports?.length &&
      !powerBiReportsData.loading &&
      !powerBiReportsData.failed
    ) {
      dispatch(fetchPowerBiReports());
    }
  }, []);

  if (settingsData.loading || powerBiReportsData.loading) {
    return (
      <>
        <NavigationWrapper />
        <Loading />
      </>
    );
  }

  if (settingsData.failed || powerBiReportsData.failed) {
    return (
      <SectionsWrapper>
        Error loading data. Please try again later.
      </SectionsWrapper>
    );
  }

  if (powerBiReportsData.reports?.length === 0) {
    return (
      <>
        <NavigationWrapper />
        <NoData />
      </>
    );
  }

  return (
    <>
      <NavigationWrapper />
      <SectionsWrapper>
        {settingsData.settings ? (
          <>
            <ShareSection
              {...settingsData.settings}
              powerBiWorkspaceId={settingsData.settings.powerBiWorkspaceId}
              powerBiSharedWorkspaceId={
                settingsData.settings.powerBiSharedWorkspaceId
              }
              powerBiEmbeddedCapacityIsEnabled={
                settingsData.settings.powerBiEmbeddedCapacityIsEnabled
              }
              isPowerBiEnabled={settingsData.settings.isPowerBiEnabled}
              codeName={settingsData.settings.projectCodeName}
              userName={userName}
              reportsList={powerBiReportsData.reports || []}
              sharedReportsList={powerBiReportsData.sharedReports || []}
              shareReport={(id: string) =>
                dispatch(createSharedPowerBiReport(id))
              }
              removeSharedReport={(id: string) =>
                dispatch(removeSharedPowerBiReport(id))
              }
              isUnauthorized={!!powerBiReportsData.isUnauthorized}
              isApprover={userRole === USER_ROLES.APPROVER}
              powerBiWorkspaceUrl={settingsData.settings.powerBiWorkspaceUrl}
              isSharedReportstTab={isSharedReportstTab}
            />
          </>
        ) : (
          <div>no data</div>
        )}
      </SectionsWrapper>
    </>
  );
};
